import React, { useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { useSelector } from "react-redux";
import { passwordReset } from "../../lib/api";
import { OPERATOR_PASSWORD_RESET } from "../../lib/config";
import toast from "react-hot-toast";

export default function ResetModal({operator}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { access_token, csrf_token, ui_size } = useSelector((state) => state.user);
  
  async function submitHandler(values) {
    setLoading(true);
    await passwordReset(
      OPERATOR_PASSWORD_RESET,
      operator.id,
      { password: values.password },
      access_token,
      csrf_token
    )
      .then(() => {
        setLoading(false);
        toast.success("Reset password reset successfully");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  return (
    <Form
      size={ui_size}
      form={form}
      wrapperCol={{ span: 16 }}
      labelCol={{ span: 8 }}
      style={{ marginTop: "32px" }}
      onFinish={submitHandler}
    >
      <Form.Item
        name="password"
        label="New Password"
        rules={[{ required: true, min : 8 }]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="confirm_password"
        label="Confirm Password"
        dependencies={["password"]}
        hasFeedback
        rules={[
          { required: true, message: "Please confirm your password!" },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("Passwords do not match!"));
            },
          }),
        ]}
      >
        <Input.Password />
      </Form.Item>
      <Row justify="end">
        <Col>
          <Form.Item>
            <Button loading={loading} type="primary" htmlType="submit">
              Confirm
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
